import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { setupSentry } from './utils/sentry';
import injectGlobals from './utils/inject-globals';
import { initializeCrossAppCache } from './utils/cross-app-cache';
import { selectSessionForMasq } from './utils/masq';
import { createRouter } from './services/router/create-router';
import './index.scss';

setupSentry();
injectGlobals();
initializeCrossAppCache();
selectSessionForMasq();

export const router = createRouter();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement, { identifierPrefix: 'hydra_' }).render(
  <React.StrictMode>
    <NuqsAdapter>
      <RouterProvider router={router} />
    </NuqsAdapter>
  </React.StrictMode>,
);
